import type { LngLatEntity } from '@/shared/entities/LngLatEntity'
import type { DriverTimelineStatus } from '../enums/DriverTimelineStatus'

export class DriverTimeLineEntity {
  date?: string
  location?: LngLatEntity
  status?: DriverTimelineStatus
  orderReferenceCode?: string | null
}
